(function () {
  'use strict';

  function initAccordion(section) {
    var items  = section.querySelectorAll('.by-ac__item');
    var panels = section.querySelectorAll('.by-ac__panel');

    function closeAll() {
      items.forEach(function (item) {
        item.classList.remove('by-ac__item--active');
        var trigger = item.querySelector('.by-ac__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
      panels.forEach(function (panel) {
        panel.classList.remove('by-ac__panel--active');
      });
    }

    function closeItem(blockId) {
      items.forEach(function (item) {
        var isMatch = item.dataset.blockId === blockId;
        if(isMatch) {
          item.classList.remove('by-ac__item--active');
        }
      });
    }

    function open(blockId) {
      closeAll()
      items.forEach(function (item) {
        var trigger = item.querySelector('.by-ac__trigger');
        var isMatch = item.dataset.blockId === blockId;
        if(isMatch){
          item.classList.add('by-ac__item--active');
        }
        if (trigger) trigger.setAttribute('aria-expanded', isMatch ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        let isMatch = (panel.dataset.blockId === blockId);
        if(isMatch) {
          panel.classList.add('by-ac__panel--active');
        }
      });
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('.by-ac__trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        if (item.classList.contains('by-ac__item--active')) {
          closeItem(item.dataset.blockId);
        } else {
          open(item.dataset.blockId);
        }
      });
    });

    const firstPanel = panels?.[0]
    if(firstPanel) {
      firstPanel.classList.add('by-ac__panel--active');
    }
  }

  function init() {
    document.querySelectorAll('.by-ac').forEach(function (section) {
      initAccordion(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.by-ac');
    if (section) initAccordion(section);
  });
})();
